export const languages = {
  en: "English",
  fr: "Français",
  it: "Italiano",
  ar: "العربية",
};

export const languagesFlags = {
  en: "gb",
  fr: "fr",
  it: "it",
  ar: "sa",
};
